import { useCart } from "@/composables/marketplace/cart";
import { useUser } from "@/composables/user";
import { ApiClient } from "@/services/apiClient";
import { assertCartExists } from "@/services/marketplace/cart";
import { type PaymentId } from "@/services/marketplace/order/orderTypes";
import { Purchase_Schema, type Purchase } from "@/services/marketplace/order/purchases";
import { assertUserIsLoggedIn, type UserId } from "@/services/user";

export const createOrder = async (sellerId: UserId): Promise<void> => {
  const { cart } = useCart();
  assertCartExists(cart.value);

  const { user } = useUser();
  assertUserIsLoggedIn(user.value);

  const form = document.createElement("form");
  form.method = "POST";
  form.action = import.meta.env.VITE_API_URL + "/api/order/order";

  const inputSellerId = document.createElement("input");
  inputSellerId.type = "hidden";
  inputSellerId.name = "sellerId";
  inputSellerId.value = sellerId.toString();
  form.appendChild(inputSellerId);

  const inputCartId = document.createElement("input");
  inputCartId.type = "hidden";
  inputCartId.name = "basket";
  inputCartId.value = cart.value.id.toString();
  form.appendChild(inputCartId);

  const inputToken = document.createElement("input");
  inputToken.type = "hidden";
  inputToken.name = "authorizationToken";
  inputToken.value = user.value.token;
  form.appendChild(inputToken);

  document.body.appendChild(form);
  form.submit();
};

export const checkPurchasePaymentStatus = (paymentId: PaymentId): Promise<Purchase> => {
  const url = "api/order/go-pay/" + paymentId;
  return ApiClient.get<Purchase>(url).then(({ data }) => Purchase_Schema.parse(data));
};
